var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcCbeth24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8444_15039)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8444_15039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9244 12C22.9244 18.0333 18.0333 22.9244 12 22.9244C5.96658 22.9244 1.07556 18.0333 1.07556 12C1.07556 5.96658 5.96658 1.07556 12 1.07556C18.0333 1.07556 22.9244 5.96658 22.9244 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.15119C6.56065 2.15119 2.15119 6.56065 2.15119 12C2.15119 17.4393 6.56065 21.8488 12 21.8488C17.4393 21.8488 21.8488 17.4393 21.8488 12C21.8488 6.56065 17.4393 2.15119 12 2.15119ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9977 2.99988V9.37657L17.2455 11.7848L11.9977 2.99988Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9983 2.99988L6.74976 11.7848L11.9983 9.37657V2.99988Z",
    fill: "#6697FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9977 15.9171V20.2499L17.2491 12.7885L11.9977 15.9171Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9983 20.2499V15.9164L6.74976 12.7885L11.9983 20.2499Z",
    fill: "#6697FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9977 14.9141L17.2455 11.7847L11.9977 9.37781V14.9141Z",
    fill: "#6697FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74976 11.7847L11.9983 14.9141V9.37781L6.74976 11.7847Z",
    fill: "#CCDCFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8444_15039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8444_15039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCbeth24);
export default __webpack_public_path__ + "static/media/ic_cbeth_24.8c0066ca1248dbad2f449dc1ce3dbbd9.svg";
export { ForwardRef as ReactComponent };